import React from "react";
import { FaExpand } from "react-icons/fa";
import { motion } from "framer-motion";

export default function FaExpandAni({ size = 16, color = "#222" }) {
  return (
    <motion.span
      whileHover={{ scale: 1.2, rotate: 90 }}
      whileTap={{ scale: 1.2, rotate: -90 }}
      transition={{
        type: "spring",
        stiffness: 300,
        damping: 20,
      }}
      style={{ display: "inline-block" }}
    >
      <FaExpand size={size} color={color} />
    </motion.span>
  );
}
